<div *ngIf="form" [formGroup]="form">
  <div
    class="venue-customer-profile-fields__row"
    [ngClass]="(deviceValue | async) === DTypes.Mobile && layout === 'signUp' ? 'venue-customer-profile-fields__row--stack' : ''">
    <div
      class="venue-customer-profile-fields__cell"
      [ngClass]="layout === 'signUp' && (deviceValue | async) !== DTypes.Mobile ? 'pr-4' : ''">
      <div [ngClass]="layout === 'signUp' ? 'sign-up__forms-input' : ''">
        <div class="ui-input__placeholder">
          <p>ИНН</p>
          <span class="require" *ngIf="layout === 'signUp'">*</span>
          <p class="error-holder" *ngIf="innValidationError">{{ innValidationError }}</p>
        </div>
        <div class="ui-input ui-input__text">
          <input
            type="text"
            formControlName="inn"
            inputmode="numeric"
            placeholder="10 или 12 цифр"
            maxlength="12"
            (blur)="onInnBlur()" />
        </div>
      </div>
    </div>
    <div
      class="venue-customer-profile-fields__cell"
      [ngClass]="layout === 'signUp' && (deviceValue | async) !== DTypes.Mobile ? 'pl-4' : ''">
      <div [ngClass]="layout === 'signUp' ? 'sign-up__forms-input' : ''">
        <div class="ui-input__placeholder">
          <p>Название организации или заведения</p>
          <span class="require" *ngIf="layout === 'signUp'">*</span>
        </div>
        <div class="ui-input ui-input__text">
          <input
            type="text"
            formControlName="venueName"
            placeholder="Как в учредительных документах"
            maxlength="300" />
        </div>
      </div>
    </div>
  </div>

  <div
    class="venue-customer-profile-fields__row"
    [ngClass]="(deviceValue | async) === DTypes.Mobile && layout === 'signUp' ? 'venue-customer-profile-fields__row--stack' : ''">
    <div
      class="venue-customer-profile-fields__cell"
      [ngClass]="layout === 'signUp' && (deviceValue | async) !== DTypes.Mobile ? 'pr-4' : ''">
      <div [ngClass]="layout === 'signUp' ? 'sign-up__forms-input' : ''">
        <div class="ui-input__placeholder">
          <p>Форма</p>
        </div>
        <div class="ui-input ui-input__text">
          <input
            type="text"
            formControlName="format"
            placeholder='Например: "тихое место, где можно расслабиться и пообщаться", или: "Даем рок на всю катушку"'
            maxlength="100" />
        </div>
      </div>
    </div>
    <div
      class="venue-customer-profile-fields__cell"
      [ngClass]="layout === 'signUp' && (deviceValue | async) !== DTypes.Mobile ? 'pl-4' : ''">
      <div [ngClass]="layout === 'signUp' ? 'sign-up__forms-input' : ''">
        <div class="ui-input__placeholder">
          <p>Тег типа площадки</p>
          <span class="require" *ngIf="layout === 'signUp'">*</span>
        </div>
        <div class="ui-input ui-input__text">
          <input
            type="text"
            formControlName="venueTypeTag"
            placeholder="Например: bar, club, hall"
            maxlength="100" />
        </div>
      </div>
    </div>
  </div>

  <div
    class="venue-customer-profile-fields__row"
    [ngClass]="(deviceValue | async) === DTypes.Mobile && layout === 'signUp' ? 'venue-customer-profile-fields__row--stack' : ''">
    <div class="venue-customer-profile-fields__cell venue-customer-profile-fields__cell--full">
      <div [ngClass]="layout === 'signUp' ? 'sign-up__forms-input' : ''">
        <div class="ui-input__placeholder">
          <p>Описание площадки</p>
        </div>
        <div class="ui-input ui-input__text">
          <textarea
            rows="3"
            formControlName="description"
            placeholder="Краткое описание"
            maxlength="1000"
            (input)="cdr.markForCheck()"></textarea>
        </div>
        <p class="txt-helper pt-1 m-0">Доступно символов для ввода: {{ descriptionCharsRemaining() }}</p>
      </div>
    </div>
  </div>

  <div
    *ngIf="layout === 'dialog'"
    class="venue-customer-profile-fields__row venue-customer-profile-fields__row--ready-beside-placeholder"
    [ngClass]="(deviceValue | async) === DTypes.Mobile ? 'venue-customer-profile-fields__row--stack' : ''">
    <div class="venue-customer-profile-fields__cell venue-customer-profile-fields__cell--spacer" aria-hidden="true"></div>
    <div class="venue-customer-profile-fields__cell">
      <div>
        <div class="ui-checkbox mt-2">
          <input
            id="readyToAcceptApplications"
            type="checkbox"
            formControlName="readyToAcceptApplications" />
          <label for="readyToAcceptApplications">
            <span class="ui-checkbox__text">Готовы принимать заявки</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div
    class="venue-customer-profile-fields__row"
    [ngClass]="(deviceValue | async) === DTypes.Mobile && layout === 'signUp' ? 'venue-customer-profile-fields__row--stack' : ''">
    <div
      class="venue-customer-profile-fields__cell"
      [ngClass]="layout === 'signUp' && (deviceValue | async) !== DTypes.Mobile ? 'pr-4' : ''">
      <div [ngClass]="layout === 'signUp' ? 'sign-up__forms-input' : ''">
        <div class="ui-input__placeholder">
          <p>Жанры</p>
          <span class="require" *ngIf="layout === 'signUp'">*</span>
          <p class="txt-helper m-0">Можно выбрать до 5 жанров</p>
        </div>
        <p-multiSelect
          formControlName="preferredGenres"
          [options]="genres"
          optionLabel="name"
          optionValue="id"
          filterBy="name"
          [filter]="true"
          filterPlaceholder="Поиск жанра..."
          placeholder="Выберите жанры"
          styleClass="p-dropdown__bulletins"
          [showHeader]="true"
          [showToggleAll]="false"
          emptyFilterMessage="Ничего не нашли..."
          [selectionLimit]="5">
        </p-multiSelect>
      </div>
    </div>
    <div
      class="venue-customer-profile-fields__cell"
      [ngClass]="layout === 'signUp' && (deviceValue | async) !== DTypes.Mobile ? 'pl-4' : ''">
      <div [ngClass]="layout === 'signUp' ? 'sign-up__forms-input' : ''">
        <div class="ui-input__placeholder">
          <p>Типы артистов</p>
          <span class="require" *ngIf="layout === 'signUp'">*</span>
          <p class="txt-helper m-0">Можно выбрать до 3 типов</p>
        </div>
        <p-multiSelect
          formControlName="preferredPerformerTypes"
          [options]="PerformerTypes"
          optionLabel="name"
          optionValue="value"
          placeholder="Выберите типы"
          styleClass="p-dropdown__bulletins"
          [showHeader]="false"
          [selectionLimit]="3">
        </p-multiSelect>
      </div>
    </div>
  </div>

  <div
    class="venue-customer-profile-fields__row"
    [ngClass]="(deviceValue | async) === DTypes.Mobile && layout === 'signUp' ? 'venue-customer-profile-fields__row--stack' : ''">
    <div
      class="venue-customer-profile-fields__cell"
      [ngClass]="layout === 'signUp' && (deviceValue | async) !== DTypes.Mobile ? 'pr-4' : ''">
      <div [ngClass]="layout === 'signUp' ? 'sign-up__forms-input' : ''">
        <div class="ui-input__placeholder">
          <p>Адрес (полный)</p>
          <span class="require" *ngIf="layout === 'signUp'">*</span>
        </div>
        <div class="ui-input ui-input__text">
          <input
            type="text"
            formControlName="addressFullAddress"
            placeholder="Город, улица, дом"
            maxlength="300" />
        </div>
      </div>
    </div>
    <div
      class="venue-customer-profile-fields__cell"
      [ngClass]="layout === 'signUp' && (deviceValue | async) !== DTypes.Mobile ? 'pl-4' : ''">
      <div [ngClass]="layout === 'signUp' ? 'sign-up__forms-input' : ''">
        <div class="ui-input__placeholder">
          <p>Как добраться</p>
        </div>
        <div class="ui-input ui-input__text">
          <input
            type="text"
            formControlName="addressDescription"
            placeholder="Ориентир, этаж и т.п."
            maxlength="300" />
        </div>
      </div>
    </div>
  </div>

  <div
    class="venue-customer-profile-fields__row"
    [ngClass]="(deviceValue | async) === DTypes.Mobile && layout === 'signUp' ? 'venue-customer-profile-fields__row--stack' : ''">
    <div
      class="venue-customer-profile-fields__cell"
      [ngClass]="layout === 'signUp' && (deviceValue | async) !== DTypes.Mobile ? 'pr-4' : ''">
      <div [ngClass]="layout === 'signUp' ? 'sign-up__forms-input' : ''">
        <div class="ui-input__placeholder">
          <p>Макс. вместимость</p>
        </div>
        <div class="ui-input ui-input__text">
          <input type="number" min="0" formControlName="maxAudienceCapacity" placeholder="Например: 300" />
        </div>
      </div>
    </div>
    <div
      class="venue-customer-profile-fields__cell"
      [ngClass]="layout === 'signUp' && (deviceValue | async) !== DTypes.Mobile ? 'pl-4' : ''">
      <div [ngClass]="layout === 'signUp' ? 'sign-up__forms-input' : ''">
        <div class="ui-input__placeholder">
          <p *ngIf="layout === 'dialog'">Площадь сцены (м2)</p>
          <p *ngIf="layout === 'signUp'">Площадь сцены (м²)</p>
        </div>
        <div class="ui-input ui-input__text">
          <input
            type="number"
            min="0"
            step="0.1"
            formControlName="stageAreaSquareMeters"
            placeholder="Например: 24.5" />
        </div>
      </div>
    </div>
  </div>

  <div class="venue-customer-profile-fields__row venue-customer-profile-fields__row--time">
    <div
      class="venue-customer-profile-fields__cell"
      [ngClass]="layout === 'signUp' && (deviceValue | async) !== DTypes.Mobile ? 'pr-4' : ''">
      <div [ngClass]="layout === 'signUp' ? 'sign-up__forms-input' : ''">
        <div class="ui-input__placeholder">
          <p>Ограничение по времени</p>
        </div>
        <div class="ui-input ui-input__text">
          <input type="time" formControlName="timeLimit" />
        </div>
      </div>
    </div>
  </div>
</div>
